(function (angular) {
    'use strict';

    angular.module('phoneValidation')
        /**
         *
         */
        .controller('phoneValidationsCtrl', ['$scope', '$stateParams', 'phoneValidationService', '$filter', 'NgTableParams', 'jwtService', '$rootScope', 'growlService', function ($scope, $stateParams, phoneValidationService, $filter, ngTableParams, jwtService, $rootScope, growlService){
            $scope.bulkValidationData = [];
            $scope.$on('phoneValidation:complete', function(){
                $scope.refresh();
            });
            $scope.$on('phoneValidation:started', function(){
                $scope.refresh();
            });
            $scope.refresh = function(){
                phoneValidationService.getBulkValidationsDetails($stateParams.pickedApiSpaceId).then(function(result){
                    for(var i in result){
                        result[i].downloadFile = $scope.downloadFile;
                    }
                    $scope.bulkValidationData = result;
                    $scope.tableSorting.reload();
                }).catch(function(error){
                    growlService.danger("Phone validation details wasn't get due to: " + error.statusText);
                });

            };

            $scope.downloadFile = function (id, jobId) {
                $rootScope.$broadcast('fileDownload', {url: "/apispaces/"+$stateParams.pickedApiSpaceId+"/phonevalidation/bulk/"+id+"/result", token: jwtService.token, fileName: "validation_report_"+jobId+".csv"});
            };

            $scope.tableSorting = new ngTableParams({
                page: 1,            // show first page
                count: 10,           // count per page
                sorting: {
                    name: 'asc'     // initial sorting
                }
            }, {
                total: $scope.bulkValidationData.length, // length of data
                getData: function($defer, params) {
                    // use build-in angular filter
                    var orderedData = params.sorting() ? $filter('orderBy')($scope.bulkValidationData, params.orderBy()) : $scope.bulkValidationData;

                    $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                    params.total(orderedData.length);
                }
            });
            $scope.refresh();
        }]);

})(window.angular);
